import { FC, Fragment } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItemGenre from '@/components/ui/book-card-item/BookCardItemGenre';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IWebtoonsProps extends IWidgetsSideBar {
  books: IGenreBooksPage;
}

const Webtoons: FC<IWebtoonsProps> = ({ books, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(books?.books.total_count / BOOKS_FOR_PAGE);

  //Seo
  const SEO_TITLE = `Бесплатно скачать книги жанра Вебтуны | Bookz.ru`;
  const SEO_DESCRIPTION = `В электронной библиотеке Bookz.ru можно скачать книги из жанра «Вебтуны»`;
  const SEO_CANONICAL = `/webtoons`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Вебтуны" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name="Вебтуны" />
      <div>
        {books.books && books.books.data.length > 0 ? (
          books.books.data.map((book, i) => (
            <Fragment key={`${book.id}-${i}`}>
              <BookCardItemGenre book={book} />
            </Fragment>
          ))
        ) : (
          <div>Нет книг</div>
        )}
      </div>
      <Pagination defaultCurrentPage={books.books.page} pagesCount={pagesCount ?? 0} postName="webtoons/page=" />
    </Layout>
  );
};

export default Webtoons;
